module.exports = __webpack_public_path__ + "img/c00_buildingtechcroprotation_Normal_ua.e9bd0cb5.webp";